import React, { useContext } from 'react';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import { LocationContext } from '../LocationContext/LocationContext';

// Icons und Marker
import InnerIcon from '../LocationMap/InnerIcon';
import DefaultMarker from '../CustomMarker/DefaultMarker';
import IconChevronDown from '../../assets/images/featherIcons/IconChevronDown';

// Styles
import styles from './MapLegend.module.scss';
import accordionStyles from '../LocationList/LocationList.module.scss';

// Helper
import ColorMapping from '../LocationMap/ColorMapping';
import mapIconMapping from '../../utils/mapIconTitles';

const DYNAMIC_PREFIXES = ['Institution_'];

const getLabel = (mapicon, legend) => {
    const isDynamic = DYNAMIC_PREFIXES.some((prefix) =>
        mapicon.startsWith(prefix)
    );

    return (
        (isDynamic && legend[mapicon]) ||
        mapIconMapping[mapicon]?.label ||
        mapicon
    );
};

const MapLegend = () => {
    const { legend } = useContext(LocationContext);

    const elements = Object.keys(mapIconMapping).map((mapicon) => ({
        mapicon,
        cssClass: mapIconMapping[mapicon]?.fullWidth ? styles.fullWidth : '',
    }));

    return (
        <Accordion allowZeroExpanded={true}>
            <AccordionItem
                className={`${accordionStyles.placeItem} ${accordionStyles.accordionItem} ${styles.item}`}
            >
                <AccordionItemHeading
                    className={accordionStyles.accordionHeading}
                >
                    <AccordionItemButton>
                        <span
                            className={[
                                accordionStyles.flexContainer,
                                styles.itemButton,
                            ].join(' ')}
                            aria-labelledby={'place_title_legend'}
                        >
                            <div className={accordionStyles.titleWrapper}>
                                <span
                                    className={accordionStyles.title}
                                    id={'place_title_legend'}
                                >
                                    Zeichenerklärung
                                </span>
                            </div>
                            <span className={styles.arrow}>
                                <IconChevronDown aria-hidden />
                            </span>
                        </span>
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <div className={styles.legend}>
                        {elements.map((element, index) => (
                            <div
                                key={index}
                                className={[
                                    styles.element,
                                    element.cssClass || '',
                                ].join(' ')}
                            >
                                <DefaultMarker
                                    className={styles.defaultMarker}
                                    height="30"
                                    width="24"
                                    fillcolor={
                                        ColorMapping[element.mapicon] ||
                                        '#1A76D0'
                                    }
                                />
                                <InnerIcon
                                    icon={element.mapicon}
                                    className={[styles.customIcon].join(' ')}
                                />
                                <div className={styles.label}>
                                    {getLabel(element.mapicon, legend)}
                                </div>
                            </div>
                        ))}
                    </div>
                </AccordionItemPanel>
            </AccordionItem>
        </Accordion>
    );
};

export default MapLegend;
